module.exports = __webpack_public_path__ + "f56820929bebc1b04c7ea8fb21a0a982.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/05-Betsolutions-Mines.png
// module id = 1727
// module chunks = 2